import { createGlobalStyle, css } from 'styled-components';

import { lgAndUp, mdAndUp, mobileOnly, smAndDown, smAndUp } from './resolution';

import {
  CONTAINER_DESKTOP,
  CONTAINER_MOBILE,
  CONTAINER_TABLET,
  GRID_GUTTER_WIDTH,
  DESKTOP_COLUMN_GAP,
  DESKTOP_COLUMN_SIZE,
} from './variables';

import { GRAY_76 } from './colors';

const CONTAINER_PADDING_LG =
  (DESKTOP_COLUMN_GAP + DESKTOP_COLUMN_SIZE) * 3 + 46;

const CommonStyles = createGlobalStyle`
  .noscroll {
    height: 100%;
    overflow: hidden;
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }

  .content-wrapper-without-actions-box {
    flex: 1 0 auto;
  }

  .fullPageAbsolute {
    position: absolute;
    height: 100%;
    width: 100%;
  }

  a,
  img,
  button {
    text-decoration: none;
    &:active,
    &:focus {
      outline: none;
    }
  }

  .btn:focus {
    outline: none !important;
  }

  .MuiFormHelperText-root {
    margin-top: 0;
  }

  .MuiFormHelperText-root {
    margin-top: 0;
  }

  .MuiInputBase-fullWidth {
    transform: translateY(2px);

    &:before {
      border-bottom: 2px solid rgba(0, 0, 0, 0);
    }

    &:after {
      content: none;
    }

    &:hover:not(.Mui-disabled):before {
      border-bottom: 2px solid ${GRAY_76};
    }
  }

  // hack for disabling background for browser's styles for autofill state
  // https://github.com/mui-org/material-ui/issues/14427#issuecomment-466054906
  input:-webkit-autofill {
    transition-delay: 9999s;
    transition-property: background-color, color;
  }

  .container {
    margin-right: auto;
    margin-left: auto;
    width: ${CONTAINER_MOBILE};
    padding-left: ${GRID_GUTTER_WIDTH * 2}px ;
    padding-right: ${GRID_GUTTER_WIDTH * 2}px ;

    &--wide {
      padding-left: 16px;
      padding-right: 16px;
    }

    ${mdAndUp(css`
      max-width: ${CONTAINER_TABLET};
      padding-left: 64px;
      padding-right: 64px;

      &--wide {
        padding-left: 32px;
        padding-right: 32px;
      }
    `)}

    ${lgAndUp(css`
      max-width: ${CONTAINER_DESKTOP};
      padding-left: ${CONTAINER_PADDING_LG}px;
      padding-right: ${CONTAINER_PADDING_LG}px;

      &--wide {
        padding-left: 133px;
        padding-right: 133px;
      }
    `)}

  }

  .actions-box-content {
    justify-content: flex-end;
    align-items: center;
    &.center {
      justify-content: center;
    }
    &.full-width {
      width: 100%;
    }
    &.left {
      justify-content: flex-start;
    }
    display: flex;
    ${mobileOnly(
      css`
        flex-direction: column-reverse;
      `
    )}
  }

  .full-width-section-content {
    justify-content: flex-start;
    &.center {
      justify-content: center;
    }
    &.right {
      justify-content: flex-end;
    }
    display: flex;
    ${mobileOnly(
      css`
        flex-direction: column-reverse;
      `
    )}
  }

  .error-wrapper {
    .error-item {
      text-align: center;
      min-width: 240px;
    }
    ${smAndDown(css`
      div {
        width: 100%;
      }
    `)}

  }

  .AppForm__snackbar {
    left: 8px;

    ${smAndUp(
      css`
        left: 50%;
      `
    )}


  }

`;

export default CommonStyles;
